module.exports = __webpack_public_path__ + "static/media/first_image.feee429b.png";